// src/pages/BlockChainDataPage.jsx
import { useParams } from "react-router-dom";
import customDevelopmentData from "../data/softwareDevelopmentData.json";
import { Helmet } from "react-helmet-async";
import AboutNavBar from "../components/AboutNavBar";
import Footer from "../components/Footer";
import RenderLinks from "../components/RenderLinks";
import { apiRequestHandler } from "../apiConfig/service";
import ApiConfig from "../apiConfig/ApiConfig";
import { useEffect, useState } from "react";
import NotFound from "../components/NotFound";
import NotFoundPage from "./NotFoundPage";
import Loader from "../components/Loader";

const CustomDevelopmentServicePage = () => {
  const { slug } = useParams();
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true)

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  // const serviceData = customDevelopmentData.find((loc) => loc.slug === slug);
  const [serviceData, setServiceData] = useState({})

  const getServiceData = async () => {
    const endPoint = ApiConfig.getServiceBySlug(slug); // 👈 dynamic URL from config
    console.log(endPoint)


    try {
      setLoading(true)
      const res = await apiRequestHandler({ method: "get", endPoint })
      console.log(res)
      if (res?.success) {
        setServiceData(res?.data || {})
      }
    } catch (error) {
      setServiceData({})
      console.log(error)
    }
    finally{
      setLoading(false)
    }
  }
  useEffect(() => {
    getServiceData();
  }, [slug])
  console.log(serviceData)
  if (loading) {
    return <Loader />;

  }
  if (Object.keys(serviceData).length === 0) return <NotFoundPage />;


  return (
    <div className="customDevelopmentData-page">
      <Helmet>
        <title>{serviceData.metaTitle}</title>
        <meta name="description" content={serviceData.metaDescription} />
        <meta name="keywords" content={serviceData.keywords} />
        <link
          rel="canonical"
          href={`https://microcodesoftware.com/${serviceData.slug}`}
        />
      </Helmet>

      {/* <RenderLinks /> */}
      <AboutNavBar />

      <div className="services-details-area default-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="site-heading text-center">
                <h4 className="sub-title">{serviceData.serviceName}</h4>
                <h1 className="title m-0">{serviceData.title}</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="services-details-items">
            <div className="row">
              <div className="col-xl-12 services-single-content">
                <div className="thumb mb-50">
                  <img
                    src={serviceData?.bannerImage}
                    alt="Thumb"
                    style={{ height: '80vh', width: '100vw' }} // React inline styles
                  />
                </div>
                <div
                  className="outfit-font"
                  dangerouslySetInnerHTML={{ __html: serviceData?.description }}
                />



              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services-content bg-gray default-padding">
        <div className="container">
          <div className="about-style-one-items">
            <div className="row">
              <div className="col-xl-7 col-lg-6">
                <div className="thumb-style-one">
                  <img src={serviceData?.whyChooseUs?.image} alt="Img Not Found" style={{ maxHeight: "400px", width: "100%" }} />
                </div>
              </div>
              <div className="col-xl-5 col-lg-6 pl-50 pl-md-15 pl-xs-15">
                <div className="about-style-one-info">
                  <div className="content">
                    <h2 className="title">{serviceData?.whyChooseUs?.title}</h2>
                    <div className="outfit-font" dangerouslySetInnerHTML={{ __html: serviceData?.whyChooseUs?.description }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="services-content default-padding">
        <div className="container">
          <div className="about-style-one-items">
            <div className="row">
              <div className="col-12">
                <div className="about-style-one-info">
                  <div className="content">
                    <h2 className="title">{serviceData.featureSection?.title}</h2>
                    <div
                      className="outfit-font"
                      dangerouslySetInnerHTML={{
                        __html: serviceData.featureSection?.description || ""
                      }}
                    ></div>
                    <h4>Features:</h4>
                    <ul className="list-style-two">
                      {serviceData.featureSection?.features?.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services-content default-padding pt-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="title">Frequently Asked Questions</h2>

              <div
                className="outfit-font"
                dangerouslySetInnerHTML={{ __html: serviceData.faqSection?.description }}
              ></div>

              <div className="accordion mt-50" id="faqAccordion">
                {serviceData.faqSection?.questions?.map((faq, index) => {
                  const isOpen = activeIndex === index;
                  const collapseId = `collapse${index}`;
                  const headingId = `heading${index}`;

                  return (
                    <div className="accordion-item accordion-style-one" key={index}>
                      <h2 className="accordion-header" id={headingId}>
                        <button
                          className={`accordion-button d-flex justify-content-between align-items-center ${!isOpen ? "collapsed" : ""
                            }`}
                          type="button"
                          onClick={() => toggleAccordion(index)}
                          aria-expanded={isOpen}
                          aria-controls={collapseId}
                        >
                          <span>{faq.question}</span>
                        </button>
                      </h2>
                      <div
                        id={collapseId}
                        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
                        aria-labelledby={headingId}
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body">
                          <div
                            className="outfit-font"
                            dangerouslySetInnerHTML={{
                              __html: faq.answer || ""
                            }}
                          />
                          {faq.points?.length > 0 && (
                            <div className="faq-points mt-2">
                              {faq.points.map((point, idx) => (
                                <p key={idx}>
                                  <strong>{point.bold}</strong> {point.text}
                                </p>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>


      <Footer />
    </div>
  );
};

export default CustomDevelopmentServicePage;
